import { useQuery } from "convex/react";
import { api } from "$convex/convexApi";
import { useAuthIdentity } from "@/contexts/UserProfileContext";

export function useOrders(limit = 500) {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.logistics.getAllOrders,
    authUserId ? { authUserId, limit } : "skip",
  );
}

export function useOrdersByStatus(status?: string, limit = 500) {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.logistics.getOrdersByStatus,
    authUserId
      ? { authUserId, ...(status ? { status } : {}), limit }
      : "skip",
  );
}

export function useOrderWithFullDetails(orderId?: string) {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.admin.getOrderWithFullDetails,
    authUserId && orderId ? { authUserId, orderId } : "skip"
  );
}

export function useOrderByNumber(orderNumber?: string) {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.admin.getOrderWithFullDetails,
    authUserId && orderNumber ? { authUserId, orderNumber } : "skip"
  );
}

export type SalesOrderScope = "orders" | "abandoned" | "both";

export interface SalesOrdersSummaryFilters {
  orderScope?: SalesOrderScope;
  productId?: string;
  cargoSearch?: string;
  contractSearch?: string;
  deliveredOnly?: boolean;
}

export function useSalesOrdersSummary(
  authUserId?: string,
  userId?: string,
  limit = 100,
  filters?: SalesOrdersSummaryFilters,
) {
  return useQuery(
    api.sales.getOrdersSummary,
    authUserId
      ? {
          authUserId,
          limit,
          userId: userId as any,
          ...(filters?.orderScope ? { orderScope: filters.orderScope } : {}),
          ...(filters?.productId ? { productId: filters.productId } : {}),
          ...(filters?.cargoSearch ? { cargoSearch: filters.cargoSearch } : {}),
          ...(filters?.contractSearch ? { contractSearch: filters.contractSearch } : {}),
          ...(filters?.deliveredOnly ? { deliveredOnly: true } : {}),
        }
      : "skip",
  );
}
